module.exports = __webpack_public_path__ + "helvetica_neu_bold-webfont.e767e5e16063a522724e.woff2";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/landing_page/src/assets/fonts/helvetica_neu_bold-webfont.woff2
// module id = ../../../../../src/assets/fonts/helvetica_neu_bold-webfont.woff2
// module chunks = styles